
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import baseUrl, {imageUrl} from "@/constants";
    import {IPage} from "@/js/page";
    import {authorizeCertApi, mechanismApi} from "@/api/organization";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    const {regionData} =require("@/js/region/region");

    @Component({
        name: "MapsList2",
        components: {TableShowRangeHead, TableShowRangeBody}
    })
    export default class MapLise2 extends Vue {
        title = "授权项目";
        listData = [] as any;
        private closePage: any;
        code = "";
        codeName = "";
        showForm = false;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        propParams = {
            itemName: '',
            organizationName: '',
            certificateNo: "",
            termValidity: "",
            termValidityEnd: "",
            orgId: '',
        } as any
        detailDialog = false;
        form = null as any;
        standardList = [] as any;
        fileList = [] as any;
        regionData = regionData;



        mounted() {
            this.code = this.$route.query.code as any;
            this.codeName = this.$route.query.codeName as any;
          this.list();
        }

        refresh() {
            this.listParam.current = 1;
            this.list();
        }

        reset() {
            for (const f in this.propParams) {
                this.propParams[f] = "";
            }
            this.refresh();
        }

        list() {
            const params = {
                ...this.listParam,
                ...this.propParams,
                organizationRegion: this.code,
                distinct: 0,
            };
            params.itemType = 0;
            params.status = 2;
            params.mode = '-';
            params.modeValue = "-";
            authorizeCertApi.pageItemV2(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                }
                this.$nextTick(() => {
                    let $table = this.$refs.table as HTMLFormElement;
                    if($table){
                        $table.doLayout();
                    }
                })
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        down(row: any) {
            try {
                var obj = JSON.parse(row);
                if (typeof obj == 'object' && obj) {
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=授权证书", '_blank');
                return false;
            }
        }
        detail(data: any) {
            this.form = data;
            this.form.authorizedAreaArr = JSON.parse(data.authorizedArea);
            this.detailDialog = true;
        }

        getRegionData(code: string, projectList: any){
            let result = null as any;
            for(let i =0; i<projectList.length; i++){
                const project = projectList[i];
                if(project.value === code){
                    result = project;
                    break;
                }else{
                    if(project.children != null){
                        const r = this.getRegionData(code, project.children);
                        if(r != null){
                            result = r;
                            break;
                        }
                    }
                }
            }
            return result;
        }
        changeChild(regionData: any){
            if(regionData != null && regionData.children != null) {
                regionData.children.forEach((child: any) => {
                    child.disabled = true;
                    if (child.children) {
                        this.changeChild(child);
                    }
                });
            }
        }
    }
